export const footerBgColor = "#fff";
export const borderFooterColor = "1px solid #dee2e6";
export const heightFooter = "60px";
export const titleFooter = "Copyright © 2023";
export const linkFooter = "https://www.adventure.co.th/home.php";
export const textCompany = "AD Venture Company Ltd";
export const textDescrip = " All rights reserved.";
// Copyright © 2023 AD Venture Company Ltd. All rights reserved.
